<template>
  <div class="box">
    <div class="col-md-12 ml-auto text-left pb-3">
      <div class=" d-inline-block">
        <h4 class="font-weight-bold" style="padding:17px 0px 5px 5px ;">Heatmaps</h4>
      </div>
    </div>    
    <splitpanes class="default-theme">
      <pane style="z-index:999;">
        <Heatmap :embed="true" paneName="1" paneurl="https://howuku.com/"></Heatmap>
      </pane>
      <pane style="position:absolute !important; width: 100% !important;">
        <Heatmap2 :embed="true" paneName="2" paneurl="https://howuku.com/"></Heatmap2>
      </pane>    
    </splitpanes>
  </div>
</template>

<script>
import { store } from '@/store'
import { mixin as clickaway } from 'vue-clickaway'
const Heatmap = () => import('@/components/HeatmapContinuous.vue')
const Heatmap2 = () => import('@/components/HeatmapContinuous.vue')
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
export default {
  mixins: [clickaway],
  components: {
    Splitpanes, 
    Pane,
    Heatmap,
    Heatmap2,
  },
  store,
  watch: {
    '$store.getters.datepicker.dashboard': {
      handler: function (date) {
      },
      deep: true
    }
  },
  data: function () {
    return {
      horizontal: true
    }
  },
  '$store.getters.tab.heatmap': {
    handler: function (x) {
      this.selectedTab = x
    }
  },
  filters: {},
  methods: {
  },
  async mounted() {
  },
  beforeMount() {

  }
}
</script>
<style>
.splitpanes__splitter {
  z-index: 999!important;  
}

.default-theme.splitpanes--vertical>.splitpanes__splitter, .default-theme .splitpanes--vertical>.splitpanes__splitter {
  width: 14px;
  margin-left: -1px;
}

.default-theme.splitpanes--vertical>.splitpanes__splitter:before, .default-theme .splitpanes--vertical>.splitpanes__splitter:before {
    margin-left: -3px;
}
.default-theme.splitpanes--vertical>.splitpanes__splitter:before, .default-theme.splitpanes--vertical>.splitpanes__splitter:after, .default-theme .splitpanes--vertical>.splitpanes__splitter:before, .default-theme .splitpanes--vertical>.splitpanes__splitter:after {
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 2px;
    height: 30px;
}

.splitpanes.default-theme .splitpanes__splitter {
    background-color: #00244f;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    -ms-flex-negative: 0;
    flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/HeatmapSplit.vue